import { render, staticRenderFns } from "./NicknamePage.vue?vue&type=template&id=0ad100a4&"
import script from "./NicknamePage.vue?vue&type=script&lang=js&"
export * from "./NicknamePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports